define(['jquery'], function ($) {
    calculatePercentScrolled();

    $('.js-page-progress button').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000).promise().done(function () {
            $('.js-page-progress').fadeOut(250);
        });
    });

    $(document).on('scroll', function () {
        calculatePercentScrolled();
    });

    function calculatePercentScrolled() {
        var currentPosition = $(window).scrollTop();

        if (currentPosition === 0) {
            $('.js-page-progress').fadeOut(250);
        } else {
            $('.js-page-progress').fadeIn(250);

            var winheight = $(window).height();
            var docheight = $(document).height();
            var trackLength = docheight - winheight;
            var pctScrolled = Math.floor(currentPosition / trackLength * 100); // gets percentage scrolled (ie: 80 NaN if tracklength == 0)
            $('.js-page-progress .pageProgress__progress').width(pctScrolled + '%');
        }
    }

});